export default __webpack_public_path__ + "static/background-5482587748f934f654931dd121220520.jpeg";